import { Navigate, useLocation } from 'react-router-dom';
import { SITE_ALARMS_PATH, SITE_LOGS_PATH } from '../../config';

const LOG_QUERY_PARAMS = ['logId', 'formId', 'version'];

/**
 * `/events` used to show alarms and logs on one page. Links that open a log keep working by
 * going to the logs page; everything else goes to the site alarms page.
 */
export const EventsRedirectElement = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const isLogLink = LOG_QUERY_PARAMS.some((param) => searchParams.has(param));

  return (
    <Navigate replace to={{ pathname: isLogLink ? SITE_LOGS_PATH : SITE_ALARMS_PATH, search }} />
  );
};
